import useWizardSetAccessTokenListener from '../hooks/use-wizard-set-access-token-listener';
import useWizardSetLocaleListener from '../hooks/use-wizard-set-locale-listener';
import useWizardNotificationEventsEmitter from '../hooks/use-wizard-notification-events-emitter';
import useWizardSetRouteListener from '../hooks/use-wizard-set-route-listener';
import useWizardSetRestrictedPathsListener from '../hooks/use-wizard-set-restricted-paths-listener';
import useWizardSetSessionStorageListener from '../hooks/use-wizard-set-session-storage-listener';

const EmbeddedProvider = ({ children }) => {
  const isAccessTokenSet = useWizardSetAccessTokenListener();
  useWizardSetLocaleListener();
  useWizardSetRouteListener();
  useWizardSetSessionStorageListener();
  useWizardSetRestrictedPathsListener();

  useWizardNotificationEventsEmitter();

  if (!isAccessTokenSet) {
    return null;
  }

  return children;
};
export default EmbeddedProvider;
